module.exports = __webpack_public_path__ + "img/9788958283065.4136883d.jpg";